var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.pageType === null)?_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"size":100,"width":5,"color":"primary","indeterminate":""}})],1):(_vm.pageType === 'OEGG')?_c('user-area'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }